import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import EMCMLoginServiceConfiguration from "./EMCMLoginServiceConfiguration";

var _default = /*#__PURE__*/function (_EMCMLoginServiceConf) {
  _inherits(_default, _EMCMLoginServiceConf);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this);
    _this.emcm.authPageLocation = "https://tax.thomsonreuters.com/gl/auth";
    _this.emcm.location = "/bin/ewp";
    _this.estore.location = "https://store.tax.thomsonreuters.com/accounting";
    _this.identityService.clientId = "trtaewp-prod";
    _this.identityService.location = "https://mytr-id-prod-identity-int.thomsonreuters.com";
    _this.onepass.location = "https://signon.thomsonreuters.com/v2";
    _this.onepass.productId = "MKTTAXEWP";

    _this.transferIframeLocations.push("https://store.tax.thomsonreuters.com/accounting/login?transfertoken=");

    _this.transferIframeLocations.push("https://site.tax.thomsonreuters.com/federatedSSO.php?transfertoken=");

    _this.signoutIframeLocations.push("https://store.tax.thomsonreuters.com/accounting/logout");

    _this.signoutIframeLocations.push("https://site.tax.thomsonreuters.com/?signout=true");

    return _this;
  }

  return _default;
}(EMCMLoginServiceConfiguration);

export { _default as default };